import { COLLECTIONS } from '../bulk-edit-audiences/collections'

const CUSTOM_AUDIENCES = COLLECTIONS['custom-audiences']

/**
 * The bulk edit custom-audience collection, loading the extra fields the move
 * needs: `apa` and `kind` tell which audiences are already in PDP or can't be
 * moved.
 */
export const COLLECTION = {
  ...CUSTOM_AUDIENCES,
  projection: [
    ...new Set([...CUSTOM_AUDIENCES.projection, 'apa', 'kind', 'status', 'destinations', 'id8']),
  ],
}
